import { render } from "./tenant_integrations.html?vue&type=template&id=18b94cf4&external"
import script from "./tenant_integrations.js?vue&type=script&lang=js&external"
export * from "./tenant_integrations.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__